import {
  IntegrationChannelType,
  IntegrationDirection,
  IntegrationType,
} from 'generated/graphql';

export interface EncodeOAuthStateParams {
  channelType: IntegrationChannelType;
  direction: IntegrationDirection;
  data: { [key: string]: string | number | boolean | undefined };
  integrationType: IntegrationType;
}

export const encodeOAuthState = ({
  channelType,
  direction,
  data,
  integrationType,
}: EncodeOAuthStateParams) => {
  const JSONToEncode = JSON.stringify({
    channelType,
    direction,
    data,
    integrationType,
  });
  return Buffer.from(JSONToEncode).toString('base64');
};
